<template>
	<div>
		<el-form :inline="true">
			<el-form-item>
				<el-input
						v-model="searchForm.orderNo"
						placeholder="订单号"
						clearable
						style="width: 200px"
				>
				</el-input>
			</el-form-item>

			<el-form-item>
				<el-button @click="getPaymentList">搜索</el-button>
			</el-form-item>
		</el-form>

		<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				border
				stripe>
			<el-table-column
					prop="orderNo"
					label="订单号"
					width="170">
			</el-table-column>
			<el-table-column
					prop="productName"
					label="商品名称"
					width="80">
			</el-table-column>
			<el-table-column
					prop="transactionId"
					label="交易编号"
					width="260">
			</el-table-column>
			<el-table-column
					prop="payerTotal"
					label="支付金额"
					width="80">
			</el-table-column>
			<el-table-column
					prop="paymentType"
					label="支付类型"
					width="80">
			</el-table-column>
			<el-table-column
					prop="tradeType"
					label="交易类型"
					width="80">
			</el-table-column>
			<el-table-column
					prop="tradeState"
					label="交易状态"
					width="90">
			</el-table-column>
			<el-table-column
					prop="content"
					label="通知参数"
					:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
					prop="createTime"
					width="160"
					label="创建时间"
			>
			</el-table-column>
		</el-table>

		<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page="page.current"
				:page-size="page.size"
				:total="page.total">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		name: "Payment",
		data() {
			return {
				searchForm: {},
				page: {
					total: 0,
					size: 10,
					current: 1,
				},
				tableData: []
			}
		},
		created() {
			this.getPaymentList(this.page)
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.page.size = val
				this.getPaymentList(this.page)
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page.current = val
				this.getPaymentList(this.page)
			},
			getPaymentList(page) {
				this.$axios.post("/uxm/payment-info/page", {
					orderNo: this.searchForm.orderNo,
					current: page == null ? this.page.current : page.current,
					size: page == null ? this.page.size : page.size,
				}).then(res => {
					this.tableData = res.data.data.records
					this.page.size = res.data.data.size
					this.page.current = res.data.data.current
					this.page.total = res.data.data.total
				})
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}

</style>
